<template>
  <div class="predefine" dir="rtl">
    <div class="">
      <div
        ref="form"
        v-model="valid"
      >
        <div >
          <v-row class="relative">
            <v-col>
              <v-text-field
                :label="$t('optionalPrice')"
                v-model="price"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col>
              <div class="choose-select">
                <v-select
                  :items="currency_items"
                  :label="$t('choose')"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_currency"
                >
                </v-select>

              </div>
            </v-col>


          </v-row>

          <div v-for="item in pre_defined_items">

            <v-row class="checkbox-row">
              <v-col v-if="item.PredefineTypeId == 1">
                <label>{{item.Text}}</label>

              </v-col>

              <v-col v-if="item.PredefineTypeId == 1">
                <v-checkbox
                  v-model="item.IsChecked"
                  :value="item.IsChecked"
                />
              </v-col>

              <v-col v-if="item.PredefineTypeId == 2">
                <v-text-field
                  v-if="item.PredefineTypeId == 2"
                  v-model="item.Value"
                  :label="item.Text"
                  value="false"
                  outlined
                />
              </v-col>

            </v-row>

          </div>


          <div class="relative device-pass">
            <v-text-field
              :label="$t('devicePassword')"
              v-model="device_password"
              outlined
            ></v-text-field>
          </div>
        </div>
        <v-row>

          <v-btn color="primary" class="enter-btn"  v-on:click="go_to_details()">
            {{ $t('sendInformation') }}
          </v-btn>

        </v-row>
        <div>



        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import {bus} from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        errors: [],
        currency_items: [],
        selected_currency: 0,
        price: '',
        branch_id: 0,
        // device_serial_number: '',
        device_password: '',
        pre_defined_items: [],

        valid: true,
        not_register: false,
        user_registered: false,
        rules: {
          required: value => !!value || this.$t('necessary'),
          fullName: value => value.length <= 30 || this.$t('max30Character'),
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || this.$t('nameNotFarsi')
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('phoneNotCorrect')
          },
        },
      }
    }, watch: {
      "mobile": function () {
        this.not_register = false;
        this.user_registered = false;
        this.fullName = "";

        console.log("mobile changed");
        if (this.mobile.length == 11 && this.level == 1) {
          this.login();
        }
      }
    },mounted() {
      this.get_currencies();
      this.get_branch_permission();
      this.get_predifined();
    },
    methods: {
      login() {
        var self = this;
        if (this.level == 1) {

          const send_data = {
            "Phone": this.mobile,
          };
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/CheckExistsMobileNo', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log("response", response);
                self.user_registered = true;
                self.fullName = response.data.msg;
                // self.level = 2;
              } else {
                self.not_register = true;
              }
              // this.$router.push({ path: "/post-login", params: {} });

            }).catch(e => {
            this.errors.push(e);

          })
        } else if (this.level == 2) {
          var eddited_mobile = self.mobile.substring(1);
          eddited_mobile = "+98" + eddited_mobile;
          if (this.mobile != '' && this.fullName != '') {

            const send_data = {
              "MobileNo": eddited_mobile,
              "Password": this.password,
              "OsName": "win",
              "AppNo": "5",
              "OsVersion": "5",
              "DeviceModel": "android",
            };
            // this.axios.post('/Register' , send_data,{
            this.axios.post('/CustomerRegistration', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log("response login", response);

                  localStorage.setItem("profile", JSON.stringify(response.data.profile))
                  localStorage.setItem("phone", eddited_mobile)
                  localStorage.setItem("password", self.password)

                  self.$router.push({path: "/post-login", params: {}});

                }

              }).catch(e => {
              this.errors.push(e);

            })
          }


        }
        if (this.mobile == "") {
          this.errors.push(this.$t('pleaseEnterYourNo'))
        }
        if (this.fullName == "") {
          this.errors.push(this.$t('enterYourNameLastName'))
        }
      },
      go_to_details() {
        // var PassingData = {'on_site_service':OnSite}
        // if (this.fullName != '') {
        var passing_data = JSON.parse(localStorage.getItem('request_data'));
        passing_data.device_password = this.device_password;
        passing_data.price = this.price;
        passing_data.currency = this.selected_currency;
        passing_data.branch_id = this.branch_id;
        // passing_data.device_serial_number = this.device_serial_number;
        passing_data.pre_defined = JSON.stringify(this.pre_defined_items);
        localStorage.setItem("request_data", JSON.stringify(passing_data));
        this.$router.push({name: 'request_detail', params: {}})
        // } else {
        //   bus.$emit('show_dialog', ["خطا", "لطفا شماره مشتری را وارد کنید"])
        //
        // }

      },
      get_currencies() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        const send_data = {
          "UserId": user_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetCurrencies', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.Currencies.forEach(function (number) {
                if(number.CurrencyName==this.$t('tooman')){
                  self.selected_currency = number.CurrencyId;
                }
                var obj = {label: number.CurrencyName, value: number.CurrencyId}
                self.currency_items.push(obj);
              });
              // response.data.parties.forEach(function(item) {
              //   console.log("sdsd"+item)
              //
              // });


            }
          }).catch(e => {
          this.errors.push(e);

        })

      },
      get_branch_permission() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        var party_id=  localStorage.getItem("party_id");


        const send_data = {
          "UserId": user_id,
          "Role": "BranchDefinition",
          "PartyId": party_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkGetUserPermission', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
             this.branch_id = response.data.UserBranchId
            }
          }).catch(e => {
          this.errors.push(e);

        })

      },

      get_predifined() {
        var self = this;
        var passing_data = JSON.parse(localStorage.getItem('request_data'));
        var user_id = passing_data.UserId;
        var typeId = passing_data.cat_id;
        var catId = passing_data.group_id;
        var subcatId = passing_data.sub_group_id;
        var brandId = passing_data.brand_id;
        var DeviceModel = passing_data.device_model;

        const send_data = {
          "TypeId": typeId,
          "CatId": catId,
          "GroupId": subcatId,
          "BrandId": brandId,
          "Model": DeviceModel,
          "Phone": DeviceModel,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PredefinedText', send_data, {})
          .then(response => {
            if (response.data.error == 0) {

self.pre_defined_items = response.data.PredefinedList;
            }
          }).catch(e => {
          this.errors.push(e);

        })

      },

    }
  }
</script>
